import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LabelComponent } from "./components/label/label.component";
import { ButtonComponent } from "./components/button/button.component";
import { AnchorComponent } from "./components/anchor/anchor.component";
import { ImageComponent } from "./components/image/image.component";
import { RadioComponent } from "./components/radio/radio.component";
import { ComboboxComponent } from "./components/combobox/combobox.component";
import { LineComponent } from "./components/line/line.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { JhaIconModule } from "@jkhy/responsive-ui-angular/jha-icon";
import { JhaDialogBoxModule } from "@jkhy/responsive-ui-angular/jha-dialog-box";
import { InputComponent } from "./components/input/input.component";
import { StageManagerComponent } from "./components/stage-manager/stage-manager.component";
import { FormsModule } from "@angular/forms";
import { JhaButtonsModule } from "@jkhy/responsive-ui-angular/jha-buttons";

@NgModule({
  declarations: [
    LabelComponent,
    ButtonComponent,
    AnchorComponent,
    ImageComponent,
    RadioComponent,
    ComboboxComponent,
    CheckboxComponent,
    LineComponent,
    InputComponent,
    StageManagerComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    JhaIconModule,
    JhaButtonsModule,
    JhaDialogBoxModule,
    FormsModule,
  ],
  exports: [StageManagerComponent],
})
export class JhaScreenModule {}
